import { AsyncPipe, TitleCasePipe, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatListItem } from '@angular/material/list';
import { Router } from '@angular/router';
import { AsmAuthStorageService, CsAgentAuthService } from '@spartacus/asm/root';
import { AuthService, AuthStorageService, CmsService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { NavigationNode, NavigationService } from '@spartacus/storefront';
import { Observable, combineLatest, of } from 'rxjs';
import { concatMap, map, mergeMap, switchMap, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { LanguageExtendService } from 'src/app/service/language/language-extend.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { PermissionsConstants } from 'src/app/service/myaccount/my-account-permission.constants';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import {
  COUNTRY_FLAG_INSTEAD,
  FLAG_ICON,
  MyaccountFeaturesConfigService,
} from 'src/app/service/myaccount/myaccount-features-config.service';
import { OAuthLoadingOverlayService } from 'src/app/service/oauth-loading-overlay/oauth-loading-overlay.service';
import { OrderHistoryService } from 'src/app/service/orders/order-history.service';
import { PaymentService } from 'src/app/service/payment/payment.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CustomLoginFormComponentService } from 'src/app/service/user/custom-login-form-component.service';
import { LogoutService } from 'src/app/service/user/logout.service';
import { showOAuthLoadingOverlay } from 'src/app/shared/oauth-loading-overlay';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../../asm/asm-constant';
import { MyAccountMobileDialogData } from '../my-account.component';

export interface NavRestrictionsModel {
  url: string[];
  styleClasses: string[];
}
@Component({
  selector: 'app-my-account-mobile',
  templateUrl: './my-account-mobile.component.html',
  styleUrls: ['./my-account-mobile.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatDialogActions, MatIcon, MatDialogContent, MatListItem, AsyncPipe, UpperCasePipe, TitleCasePipe],
})
export class MyAccountMobileComponent implements OnInit {
  showSubSubMenu: boolean[] = [];
  globalMsg = document.querySelector('cx-global-message');
  activeI: number;
  activeLanguage: string;
  activeLanguageData$: any;
  activeLanguageIsocode: string;
  activeLanguageCountryIsocode: string;
  activeLanguageName: string;
  myAccountMobileNavNode: any[] = [];
  headerLinksMobileNavEntries: any[] = [];
  languageMobileNavNode: any[] = [];
  headerLinksPositionId = 'HeaderLinks';
  myAccountLinksPositionId = 'MyAccount';
  myAccountLinks: any[];
  myAccountLinksOverride: any[];
  headerLinksNavNode$: Observable<NavigationNode>;
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  shimanoActiveLanguageData: any;

  activeCountry$: Observable<string> = this.countryService.getActive();

  isLanguageFlagIconEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, FLAG_ICON)
    )
  );

  isCountryFlagInsteadEnabled$: Observable<boolean> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, COUNTRY_FLAG_INSTEAD)
    )
  );

  @HostListener('window:resize')
  onResize(): void {
    this.closeMyAccountMobileDialog();
  }

  constructor(
    public myAccountMobileDialogRef: MatDialogRef<MyAccountMobileComponent>,
    private cmsService: CmsService,
    private router: Router,
    private languageService: ShimanoLanguageService,
    private languageExtendService: LanguageExtendService,
    private cdr: ChangeDetectorRef,
    private service: NavigationService,
    private componentService: ComponentService,
    private countryService: ShimanoCountryService,
    private myaccountFeaturesConfigSerivce: MyaccountFeaturesConfigService,
    protected authStorageService: AuthStorageService,
    protected asmAuthStorageService: AsmAuthStorageService,
    protected authService: AuthService,
    protected asmAuthService: CsAgentAuthService,
    private orderHistoryService: OrderHistoryService,
    private storageService: StorageService,
    private logoutService: LogoutService,
    private myAccountPermissionService: MyAccountPermissionService,
    private paymentService: PaymentService,
    private globalMessageService: GlobalMessageService,
    private renderer: Renderer2,
    private oauthOverlayService: OAuthLoadingOverlayService,
    private customLoginFormService: CustomLoginFormComponentService,
    @Inject(MAT_DIALOG_DATA) public data: MyAccountMobileDialogData
  ) {}

  ngOnInit() {
    this.getMyAccountLinks();
    this.getHeaderLinksNavNodeAndLanguageItems();
    this.setLanguageVariables();
  }

  onClickSubMenu($event: any, index: number) {
    $event.stopPropagation();
    if (this.showSubSubMenu[index]) {
      this.showSubSubMenu[index] = false;
    } else {
      this.showSubSubMenu[index] = true;
    }
  }

  onClick(goToUrl: string, styleClasses: string) {
    if (goToUrl.includes('asm=false') && this.asmEnabled) {
      this.authStorageService
        .getToken()
        .pipe(take(1))
        .subscribe((token) => {
          if (this.asmAuthStorageService.getTokenTarget()) {
            const showSrp = this.storageService.getLocalStorageItem('showSrp');
            this.storageService.clearLocalStorageItem();
            this.storageService.setLocalStorageitem(ASM_ENABLED_LOCAL_STORAGE_KEY, 'true');
            this.storageService.setLocalStorageitem('showSrp', showSrp);
            this.storageService.setSessionStorageItem('showSrp', showSrp); //add showSRP in sessionStorage
            this.storageService.removeSessionStorageItem('standardLoginTriggered');
            this.storageService.setSessionStorageItem('asmLoginTriggered', 'true');
            this.oauthOverlayService.setLogoutFlag();
            showOAuthLoadingOverlay();
            this.logoutService.logout();
            this.router.navigate(['login'], { queryParams: { asm: 'true' } });
          }
          this.asmAuthService.logoutCustomerSupportAgent();
          this.closeMyAccountMobileDialog();
        });
    } else {
      if (goToUrl.includes('/logout')) {
        // this.logoutService.logout();
        this.oauthOverlayService.setLogoutFlag();
        showOAuthLoadingOverlay();

        const logoutContext = this.customLoginFormService.getContextFromUrl(this.router.url);
        if (logoutContext) {
          sessionStorage.setItem('logoutContext', JSON.stringify(logoutContext));
        }
        this.storageService.removeSessionStorageItem('asmLoginTriggered');
        this.storageService.setSessionStorageItem('standardLoginTriggered', 'true');
        this.authService.coreLogout().finally(() => {
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
          this.router.navigate(['login']);
          window.location.reload();
        });
      } else if (styleClasses !== undefined) {
        this.styleClassesCheck(styleClasses);
        // this.closeMyAccountMobileDialog();
      } else {
        this.closeMyAccountMobileDialog();
        this.router.navigateByUrl(goToUrl);
      }
      this.cmsService
        .getCurrentPage()
        .pipe(
          take(1),
          map((page) => page.label)
        )
        .subscribe((pageLabel: string) => {
          if (goToUrl.includes('orders')) {
            this.orderHistoryService.refreshOrders(true, pageLabel === '/orders');
          }
        });
    }
  }

  styleClassesCheck(className: string) {
    switch (className) {
      case 'snappayInvoicesLink':
        this.onRedirectToSnappayInvoice();
        break;
      // add new class here
      default:
        break;
    }
  }
  onRedirectToSnappayInvoice() {
    this.paymentService
      .redirectToSnappayInvoice()
      .pipe(take(1))
      .subscribe({
        next: (invoiceData) => {
          this.paymentService.fullPageOverlaySpinner('hide');
        },
        error: (err) => {
          this.paymentService.fullPageOverlaySpinner('hide');
          setTimeout(() => {
            if (this.globalMsg) {
              this.renderer.addClass(this.globalMsg, 'showCxGlobalMessage');
              this.globalMessageService.add({ key: 'error.snappaySsoToken' }, GlobalMessageType.MSG_TYPE_ERROR);
            }
          });
        },
      });
  }

  get languageItems$(): Observable<any> {
    return this.languageService.getAll();
  }

  getLanguageItems() {
    const selectedLanguageOnLogin = this.storageService.getLocalStorageItem('selectedLanguageOnLogin');
    const asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
    if (selectedLanguageOnLogin && !asmEnabled) {
      this.setShimanoActiveLanguage(selectedLanguageOnLogin, true);
    } else {
      this.getShimanoActiveLanguage();
    }
  }

  getHeaderLinks() {
    this.cmsService
      .getContentSlot(this.headerLinksPositionId)
      .pipe(take(1))
      .subscribe((pos) => {
        const headerUid = pos.components[0].uid;
        this.cmsService
          .getComponentData(headerUid)
          .pipe(take(1))
          .subscribe((headerLinks: any) => {
            this.headerLinksMobileNavEntries = [...headerLinks['navigationNode'].entries];
          });
      });
  }

  getMyAccountLinks() {
    this.cmsService
      .getContentSlot(this.myAccountLinksPositionId)
      .pipe(take(1))
      .subscribe((pos) => {
        const accountUid = pos.components[0].uid;
        this.cmsService
          .getComponentData(accountUid)
          .pipe(
            take(1),
            mergeMap((componentData) =>
              combineLatest([
                this.service.getNavigationNode(of(componentData)).pipe(take(1)),
                this.getNavRestrictions(),
              ])
            )
          )
          .subscribe(([myAccountLinks, restrictions]) => {
            this.myAccountLinks = [myAccountLinks];
            this.myAccountLinksOverride = restrictions
              ? [this.myAccountNavOverride(restrictions, { ...myAccountLinks })]
              : null;
          });
      });
  }

  setLanguageVariables() {
    this.activeLanguageIsocode = this.data.activeLanguageIsocode;
    this.activeLanguageName = this.data.activeLanguageName;
    this.activeLanguageCountryIsocode = this.data.activeLanguageCountryIsocode;
    this.languageMobileNavNode = this.data.languageMobileNavNode;
  }

  getHeaderLinksNavNodeAndLanguageItems() {
    this.getHeaderLinks();
    this.getLanguageItems();
  }

  setShimanoActiveLanguage(language: string, fromLogin = false) {
    this.languageExtendService
      .setShimanoActiveLanguage(language)
      .pipe(
        take(1),
        concatMap(() => {
          this.languageService.setActive(language);
          return this.languageExtendService.getShimanoActiveLanguage();
        })
      )
      .subscribe((activeLanguage) => {
        this.shimanoActiveLanguageData = activeLanguage.language;
        this.activeLanguageName = activeLanguage.language.name;
        this.activeLanguageCountryIsocode = activeLanguage.language.country.isocode;
        this.activeLanguageIsocode = activeLanguage.language.isocode;
        this.getMyAccountLinks();
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
        if (fromLogin) {
          this.storageService.removeLocalStorageItem('selectedLanguageOnLogin');
          this.componentService.isPageLoadedFromLogin$.next(true);
          window.location.reload();
        }
      });
  }

  getShimanoActiveLanguage() {
    this.languageExtendService
      .getShimanoActiveLanguage()
      .pipe(take(1))
      .subscribe((activeLanguage) => {
        this.languageService.setActive(activeLanguage.language.isocode);
        this.shimanoActiveLanguageData = activeLanguage.language;
        this.getMyAccountLinks();
      });
  }

  closeMyAccountMobileDialog(): void {
    this.myAccountMobileDialogRef.close();
  }

  getNavRestrictions(): Observable<NavRestrictionsModel> {
    return this.myAccountPermissionService.currentUserPermissions$.pipe(
      map((permissions: any) => {
        if (permissions) {
          let restrictions: NavRestrictionsModel = { url: [], styleClasses: [] };
          // add additional My Account Nav Restrictions here
          if (!permissions.includes(PermissionsConstants.VIEW_ORDER_HISTORY)) {
            restrictions.url.push(PermissionsConstants.ORDER_HISTORY_PAGE_ID);
          }
          if (!permissions.includes(PermissionsConstants.VIEW_AND_PAY_INVOICES)) {
            restrictions.styleClasses.push(PermissionsConstants.SNAPPAY_INVOICE_STYLECLASSES);
          }
          return restrictions;
        }
      })
    );
  }

  myAccountNavOverride(restrictions: NavRestrictionsModel, nav: any): any {
    let newNav = JSON.parse(JSON.stringify(nav));
    restrictions.url.forEach((url: string) => {
      // remove from My Account Nav
      const index = newNav.children.map((nav: any) => nav.url).indexOf(url);
      if (index > -1) newNav.children.splice(index, 1);
    });
    restrictions.styleClasses.forEach((styleClasses: string) => {
      // remove from My Account Nav
      const index = newNav.children.map((nav: any) => nav.styleClasses).indexOf(styleClasses);
      if (index > -1) newNav.children.splice(index, 1);
    });
    return newNav;
  }
}
